var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInstagram2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 5.5,
    stroke: "#5A5A5A",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9994 15.4042C22.9993 15.2696 22.9991 15.1349 22.9991 15C22.9991 14.8492 22.9993 14.6986 22.9996 14.5482C23.001 13.5963 23.0024 12.6501 22.9471 11.6979C22.885 10.417 22.5948 9.28227 21.6562 8.34366C20.7196 7.40704 19.5829 7.11485 18.302 7.05281C17.3339 6.99834 16.3719 6.9994 15.4039 7.00048C15.2693 7.00062 15.1347 7.00077 14.9998 7.00077C14.8653 7.00077 14.7309 7.00062 14.5965 7.00048C13.6298 6.9994 12.6676 6.99834 11.6977 7.05281C10.4168 7.11485 9.28209 7.40504 8.34348 8.34366C7.40686 9.28027 7.11467 10.417 7.05263 11.6979C6.99816 12.666 6.99923 13.6296 7.0003 14.5966C7.00045 14.731 7.0006 14.8655 7.0006 15C7.0006 15.1346 7.00045 15.269 7.0003 15.4034C6.99923 16.3701 6.99816 17.3323 7.05263 18.3022C7.11467 19.583 7.40486 20.7178 8.34348 21.6564C9.28009 22.593 10.4168 22.8852 11.6977 22.9472C12.6658 23.0017 13.6278 23.0007 14.5957 22.9996C14.7303 22.9994 14.865 22.9993 14.9998 22.9993C15.1344 22.9993 15.2689 22.9994 15.4032 22.9996C16.3699 23.0007 17.3321 23.0017 18.302 22.9472C19.5829 22.8852 20.7176 22.595 21.6562 21.6564C22.5928 20.7198 22.885 19.583 22.9471 18.3022C23.0015 17.3341 23.0005 16.3721 22.9994 15.4042ZM10.8932 15C10.8932 12.7285 12.7264 10.8953 14.9978 10.8953C17.2693 10.8953 19.1025 12.7285 19.1025 15C19.1025 17.2715 17.2693 19.1047 14.9978 19.1047C12.7264 19.1047 10.8932 17.2715 10.8932 15ZM18.312 19.2728C18.312 18.7425 18.7403 18.3142 19.2707 18.3142C19.801 18.3142 20.2273 18.7405 20.2293 19.2728C20.2293 19.8032 19.801 20.2315 19.2707 20.2315C18.7403 20.2315 18.312 19.8032 18.312 19.2728ZM12.3303 15C12.3303 16.469 13.5291 17.6678 14.9981 17.6678C16.467 17.6678 17.6658 16.469 17.6658 15C17.6658 13.531 16.467 12.3323 14.9981 12.3323C13.5291 12.3323 12.3303 13.531 12.3303 15Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram2);
export default __webpack_public_path__ + "static/media/icon_instagram_2.75921717acdd11d0e62df4c763aaf814.svg";
export { ForwardRef as ReactComponent };